<template>
    <div>
        <DeleteSchemaForm v-if="deletionFlag" @acceptDeleteschema="deleteSchema" @close="deletionFlag = false" :schema="schemaForDeletion" />

        <div v-if="deleteCategoryFlag" class="fixed shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-[#252526] z-[40] p-4 rounded-[10px] mt-[-20px] w-[250px]">
            <div class="text-center mb-3 text-[#FFF]">Ви дійсно хочете видалити категорію {{ categoryForDeletion.name }}?</div>
            <div class="flex justify-between">
                <button @click="deleteCategory(categoryForDeletion.id)" class="bg-[#DA4167] hover:bg-opacity-90 text-white px-4 py-1 rounded-[10px]">Так</button>
                <button @click="deleteCategoryFlag = false" class="px-4 py-1 rounded-[10px] bg-[#BD9135]">Ні</button>
            </div>
        </div>
        <div v-if="schemeCategoriesFlag" @click="schemeCategoriesFlag = false" class="backdrop-blur fixed top-0 left-0 w-full h-full z-[10]"></div>
        <div v-if="schemeCategoriesFlag" class="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-10 bg-[#1c1c1c] border-[1px] border-[#252526] rounded-md w-[400px] h-[400px]">
            <div class="text-center text-white mt-[10px]">Категорії схем</div>
            
            <div class="h-[250px] overflow-y-auto mt-[20px]">
                <div v-if="allCategories.length" v-for="category in allCategories" class="flex items-center justify-between mt-[10px]">
                    <div v-if="!category.edit" class="text-white px-[28px] py-[5px]">{{ category.name }}</div>
                    <div v-else class="flex gap-[10px] px-[20px]">
                        <input v-model="category.name" type="text" class="w-[100px] bg-[#252526] h-[30px] text-[#FFF] rounded-[5px] outline-none px-2" placeholder="Назва категорії">
                    </div>

                    <div class="flex gap-[10px] px-[20px]">
                        <div v-if="!category.edit" @click="category.edit = !category.edit" class="cursor-pointer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 20H21" stroke="#F8FF82" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 20H21" stroke="#DE3A73" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 20H21" stroke="#ABD3EC" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.5 3.50023C16.8978 3.1024 17.4374 2.87891 18 2.87891C18.2786 2.87891 18.5544 2.93378 18.8118 3.04038C19.0692 3.14699 19.303 3.30324 19.5 3.50023C19.697 3.69721 19.8532 3.93106 19.9598 4.18843C20.0665 4.4458 20.1213 4.72165 20.1213 5.00023C20.1213 5.2788 20.0665 5.55465 19.9598 5.81202C19.8532 6.06939 19.697 6.30324 19.5 6.50023L7 19.0002L3 20.0002L4 16.0002L16.5 3.50023Z" stroke="#F8FF82" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.5 3.50023C16.8978 3.1024 17.4374 2.87891 18 2.87891C18.2786 2.87891 18.5544 2.93378 18.8118 3.04038C19.0692 3.14699 19.303 3.30324 19.5 3.50023C19.697 3.69721 19.8532 3.93106 19.9598 4.18843C20.0665 4.4458 20.1213 4.72165 20.1213 5.00023C20.1213 5.2788 20.0665 5.55465 19.9598 5.81202C19.8532 6.06939 19.697 6.30324 19.5 6.50023L7 19.0002L3 20.0002L4 16.0002L16.5 3.50023Z" stroke="#DE3A73" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.5 3.50023C16.8978 3.1024 17.4374 2.87891 18 2.87891C18.2786 2.87891 18.5544 2.93378 18.8118 3.04038C19.0692 3.14699 19.303 3.30324 19.5 3.50023C19.697 3.69721 19.8532 3.93106 19.9598 4.18843C20.0665 4.4458 20.1213 4.72165 20.1213 5.00023C20.1213 5.2788 20.0665 5.55465 19.9598 5.81202C19.8532 6.06939 19.697 6.30324 19.5 6.50023L7 19.0002L3 20.0002L4 16.0002L16.5 3.50023Z" stroke="#ABD3EC" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div v-else @click="() => {category.edit = !category.edit; updateCategory(category.id, category.name)}" class="cursor-pointer">
                            <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 21V18C6 16.1144 6 15.1716 6.58579 14.5858C7.17157 14 8.11438 14 10 14C11.8856 14 12.8284 14 13.4142 14.5858C14 15.1716 14 16.1144 14 18V21" stroke="#339989" stroke-width="1.5" stroke-linejoin="round"/>
                                <path d="M8 6H12" stroke="#339989" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1 10.8584C1 6.28199 1 3.99376 2.38674 2.54394C2.43797 2.49038 2.49038 2.43797 2.54394 2.38674C3.99376 1 6.28199 1 10.8584 1C11.943 1 12.4655 1.00376 12.9628 1.18936C13.4417 1.3681 13.8429 1.70239 14.6452 2.37099L16.8411 4.20092C17.9027 5.08561 18.4335 5.52795 18.7168 6.13266C19 6.73737 19 7.42833 19 8.81025V12C19 15.7497 19 17.6246 18.0451 18.9389C17.7367 19.3634 17.3634 19.7367 16.9389 20.0451C15.6246 21 13.7497 21 10 21C6.25027 21 4.3754 21 3.06107 20.0451C2.6366 19.7367 2.26331 19.3634 1.95491 18.9389C1 17.6246 1 15.7497 1 12V10.8584Z" stroke="#339989" stroke-width="1.5"/>
                            </svg>
                        </div>
                        <div @click="() => { categoryForDeletion = category; deleteCategoryFlag = true }" class="cursor-pointer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 6H5H21" stroke="#DE3A73" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#DE3A73" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10 11V17" stroke="#DE3A73" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14 11V17" stroke="#DE3A73" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div v-else class="text-center text-white mt-[10px] opacity-20">Немає категорій</div>
            </div>
            
            <div class="flex flex-col items-center justify-center mt-[10px]">
                <input v-model="newCategoryName" type="text" class="w-[90%] bg-[#252526] h-[30px] text-[#FFF] rounded-[5px] outline-none px-2" placeholder="Пошук...">
                <button @click="addNewCategory" class="bg-[#5AC47D] hover:bg-opacity-90 font-semibold rounded-[5px] text-center w-[228px] py-[4px] mb-[6px] mt-[10px]">Додати категорію</button>
            </div>
        </div>

        <div class="flex justify-between px-[84px]">
            <div class="flex gap-[10px]">
                <InputComponent :value="searchQuery" @update:modelValue="e => searchQuery = e" placeholder="Пошук..." class="w-[250px] z-0"/>
                <select v-model="selectedCategory" class="w-[250px] bg-[#252526] h-[30px] text-[#FFF] rounded-[5px] outline-none px-2">
                    <option value="all">Всі категорії</option>
                    <option v-for="category in allCategories" :value="category.id">{{ category.name }}</option>
                    <!-- <option value="inactive">Неактивні</option> -->
                </select>
            </div>

            <div class="w-max flex justify-end">
                <div class="ml-[20px] flex items-center w-[110px] justify-between mr-[140px] text-[#FFF]">
                    <img @click="prevPage" src="@/desktopApp/assets/icons/left_arrow.svg" class="cursor-pointer">
                    <div class="flex mx-[20px]">Сторінка: <input v-model="page" type="number" class="bg-transparent mx-2 w-[5ch] outline-none px-1"> / <span class="ml-[10px]">{{ maxPage }}</span></div>
                    <img @click="nextPage" src="@/desktopApp/assets/icons/right_arrow.svg" class="cursor-pointer">
                </div>
                <div class="w-[228px] mr-[10px]">
                    <ButtonComponent :positive="true" @click="() => schemeCategoriesFlag = true">Додати категорію</ButtonComponent>
                </div>
                <div class="w-[228px]">
                    <ButtonComponent @click="() => $router.go(-1)">Назад</ButtonComponent>
                </div>
            </div>
        </div>

        <div class=" w-[90%] mx-auto mt-3 mb-5 rounded-[10px] overflow-y-auto">
            <table class="w-full">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                        <th class="py-2 w-[20%] text-start font-bold text-sm">Назва схеми</th>

                        <th class="px-3 w-[25%] py-2 text-end font-bold text-sm"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="schema in schemas" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <td class="px-3 py-2 text-center font-medium text-sm w-[250px]">
                            <img :src="apiUrl + 'static/' + schema.filename" @error="schema.pictureError = true" class="absolute opacity-0 w-[1px] h-[1px]">
                            <div class="svg-container" :style="[schema.pictureError ? '' : `background-image: url('${apiUrl + 'static/' + schema.filename}');`]"></div>
                        </td>
                        <td class=" py-2 w-[20%] text-start font-medium text-sm">
                            <div>
                                <div class="text-[15px] font-bold">{{ schema.name }}</div>
                                <div class="text-[12px] text-gray-600">{{ schema.category_name ? schema.category_name : 'Без категорії' }}</div>
                            </div>
                        </td>
                        <td class="px-3 w-[25%] py-2 text-end font-medium text-sm">
                            <button 
                                v-if="elementId"
                                class="py-1 rounded-[10px] text-sm font-medium mr-[20px]"
                                @click="addToElement(schema.id)"
                            >
                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="13" cy="13" r="13" fill="#5AC47D"/>
                                    <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                                    <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                                </svg>
                            </button>
                            <button 
                                v-if="!elementId"
                                class="py-1 rounded-[10px] text-sm font-medium mr-[20px]"
                                @click="$router.push('/training-schemes?schema_id=' + schema.id)"
                            >
                                <img 
                                    src="@/desktopApp/assets/icons/pen_icon.svg" 
                                    class="w-6 h-6"
                                >
                            </button>
                            <button 
                                v-else
                                class="py-1 rounded-[10px] text-sm font-medium mr-[20px]"
                                @click="$router.push('/training-schemes?schema_id=' + schema.id + '&element_id=' + elementId)"
                            >
                                <img 
                                    src="@/desktopApp/assets/icons/pen_icon.svg" 
                                    class="w-6 h-6"
                                >
                            </button>
                            <button 
                                v-if="currentAdminRole != 'supervisor'"
                                class="py-1 rounded-[10px] text-sm font-medium text-red-600"
                                @click="() => { schemaForDeletion = schema; deletionFlag = true; }"
                            >
                                <img 
                                    src="@/desktopApp/assets/icons/trash_icon.svg" 
                                    class="w-6 h-6"   
                                >
                            </button>
                        </td>
                    </tr>
                    <!-- <tr v-else>
                        <td class="px-3 py-2 w-[20%] text-center font-bold text-white" colspan="8">Немає елементів</td>
                    </tr> -->
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { useRoute, useRouter } from 'vue-router';
import { ref, onMounted, watch } from 'vue'
import { getAllTrainingSchemasRequest, getAllSchemasCount, deleteSchemaByIdRequest, saveNewSchema, addNewSchemaCategory, getAllSchemaCategories, updateSchemaCategoryById, deleteSchemaCategoryById, getSchemasByCategoryId } from '@/desktopApp/services/apiRequests'

import DeleteSchemaForm from './DeleteSchemaForm.vue';

export default {
    name: 'SchemasTable',

    setup(props, { emit }) {
        const route = useRoute()
        const router = useRouter()

        const elementId = ref(route.query.element_id)

        const schemas = ref([])
        const page = ref(1)
        const maxPage = ref(1)

        const schemasCount = ref(0)

        const apiUrl = process.env.VUE_APP_API_URL

        const searchQuery = ref('')

        const schemaForDeletion = ref(null)
        const deletionFlag = ref(false)

        const schemeCategoriesFlag = ref(false)
        const allCategories = ref([])
        const selectedCategory = ref('all')
        const newCategoryName = ref('')

        const deleteCategoryFlag = ref(false)
        const categoryForDeletion = ref(null)

        const addNewCategory = async () => {
            const newCategory = {
                name: newCategoryName.value,
                id: new Date().getTime(),
            }
            allCategories.value.push(newCategory)

            await addNewSchemaCategory(newCategory)
            allCategories.value = await getAllSchemaCategories()

            newCategoryName.value = ''
        }

        const deleteCategory = async (categoryId) => {
            allCategories.value = allCategories.value.filter(category => category.id !== categoryId)
            await deleteSchemaCategoryById(categoryId)
            deleteCategoryFlag.value = false
        }

        const updateCategory = async (categoryId, newName) => {
            const category = allCategories.value.find(category => category.id === categoryId)
            if (category) {
                category.name = newName
                await updateSchemaCategoryById(categoryId, { id: category.id,  name: newName })
                console.log('Category updated:', category)
                allCategories.value = await getAllSchemaCategories()
            }
        }

        const deleteSchema = async () => {
            if (schemaForDeletion.value) {
                await deleteSchemaByIdRequest(schemaForDeletion.value.id)
                deletionFlag.value = false
                schemaForDeletion.value = null
                await updateSchemas()
            }
        }

        const nextPage = () => {
            if (page.value < maxPage.value)
                page.value++
            else
                page.value = 1
        }

        const prevPage = () => {
            if (page.value > 1) {
                page.value--
            } else {
                page.value = maxPage.value
            }
        }

        watch(page, async () => {
            schemas.value = await getAllTrainingSchemasRequest(20, (page.value - 1) * 20, searchQuery.value)
        })

        watch(searchQuery, async () => {
            schemas.value = await getAllTrainingSchemasRequest(20, (page.value - 1) * 20, searchQuery.value)
        })

        watch(selectedCategory, async () => {
            console.log('selectedCategory.value --------- ', selectedCategory.value)
            if (selectedCategory.value === 'all') {
                schemas.value = await getAllTrainingSchemasRequest(20, (page.value - 1) * 20, searchQuery.value)
            } else {
                console.log('selectedCategory.value --------- ', selectedCategory.value)
                schemas.value = await getSchemasByCategoryId(selectedCategory.value, 20, (page.value - 1) * 20)
            }
        })

        const updateSelectedCategory = async () => {
            if (selectedCategory.value === 'all') {
                schemas.value = await getAllTrainingSchemasRequest(20, (page.value - 1) * 20, searchQuery.value)
            } else {
                schemas.value = await getSchemasByCategoryId(selectedCategory.value, 20, (page.value - 1) * 20)
            }
        }

        onMounted(async () => {
            schemas.value = await getAllTrainingSchemasRequest(20, (page.value - 1) * 20, searchQuery.value)
            console.log('schemas.value --------- ', schemas.value)

            schemasCount.value = await getAllSchemasCount()
            maxPage.value = Math.ceil(schemasCount.value / 20)

            allCategories.value = await getAllSchemaCategories()
        })

        const updateSchemas = async () => {
            schemas.value = await getAllTrainingSchemasRequest(20, (page.value - 1) * 20, searchQuery.value)
            schemasCount.value = await getAllSchemasCount()
            maxPage.value = Math.ceil(schemasCount.value / 20)
        }

        const addToElement = async (schema_id) => {
            const schemaId = schema_id
            const elementId = route.query.element_id
            router.push({ path: '/training-element/' + elementId, query: { schema_id: schemaId } })
        }

        const currentAdminRole = ref(localStorage.getItem('userType'))

        return {
            schemas,
            page,
            nextPage,
            prevPage,
            searchQuery,
            apiUrl,
            maxPage,
            schemasCount,
            schemaForDeletion,
            deletionFlag,
            deleteSchema,
            elementId,
            currentAdminRole,
            addToElement,
            schemeCategoriesFlag,
            allCategories,
            selectedCategory,
            newCategoryName,
            addNewCategory,
            deleteCategory,
            updateCategory,
            deleteCategoryFlag,
            categoryForDeletion,
            updateSelectedCategory,
        }
    },

    components: {
        DeleteSchemaForm
    }
}

</script>
<style lang="scss">
    .svg-container {
        width: 220px;
        height: 160px;
        background-size: cover;
        background-image: url('@/desktopApp/assets/no-photo.svg');
    }
</style>